export const TEAMS = [
  {
    text: 'Product',
    value: 'Product',
  },
  {
    text: 'Customer Success',
    value: 'Customer Success',
  },
  {
    text: 'Sales',
    value: 'Sales',
  },
  {
    text: 'Engineering',
    value: 'Engineering',
  },
  {
    text: 'Marketing',
    value: 'Marketing',
  },
  {
    text: 'Finance',
    value: 'Finance',
  },
  {
    text: 'instaride',
    value: 'instaride',
  },
  {
    text: 'Treasury',
    value: 'Treasury',
  },
  {
    text: 'Drivers',
    value: 'Drivers',
  },
  {
    text: 'HR',
    value: 'HR',
  },
  {
    text: 'Accounting',
    value: 'Accounting',
  },
  {
    text: 'Sourcing',
    value: 'Sourcing',
  },
  {
    text: 'Credit Control',
    value: 'Credit Control',
  },
];

export const STATUS_OPTIONS = [
  {
    text: 'Pending',
    value: 'Pending',
  },
  {
    text: 'In Progress',
    value: 'In Progress',
  },
  {
    text: 'Done',
    value: 'Done',
  },
];
